module.exports = __webpack_public_path__ + "img/lxwmImg.a2941bff.png";